import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js';

import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { LocationHours } from 'js/components/LocationHours/index--override.js';
import { ResultList } from 'js/common/modules/ResultList.js';
import { LocatorCobalt } from 'js/components/Cobalt/Locator/Common/LocatorCobalt.js';
import { Instance as MapsAPI } from 'js/components/Maps/GoogleMapsAPI.js';
import { setupTooltip } from './common/helper';


Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  LocationHours.loadAndRun();
  LocatorCobalt.init();
  ResultList.setup();
  MapsAPI.load();
  setupTooltip();

  const prefixRegex = /^[0-9]{1,4}$/;
  const searchInput = document.getElementById('q');

  searchInput.addEventListener('input', () => {
    $('.prefix-match').remove();
    const query = searchInput.value;
    if (query.match(prefixRegex)) {
      const liveUrl = `https://liveapi.yext.com/v2/accounts/me/entities?api_key=e0a4bfc4721bdef9b28be4b0320a9eb8&v=20181113&filter=%7Bc_prefix%3A%7B%24eq%3A%22${query}%22%7D%7D&fields=address`;
      const fetchInit = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
        }
      };

      fetch(liveUrl, fetchInit).then((resp) => resp.json()).then((results) => {
        const autocomplete = document.querySelector('.pac-container');

        // if there's a prefix match, want to store a data attribute w/ the branch num
        // so we can use it in Locator--override.js
        // the query is the branch num, that data isn't actually stored in the results
        if (results.response.entities.length > 0) {
          searchInput.setAttribute('data-prefix-match', query);
        }

        results.response.entities.forEach((entity) => {
          const newItem = document.createElement('div');
          newItem.setAttribute('class', 'pac-item prefix-match pac-item-selected');
          newItem.innerHTML = `
            <span class="prefix-icon"></span>
            <span class="pac-item-query">
              <span class="pac-matched">Branch ${query}</span>
              ${entity.address.line1}
            </span>
            <span>${entity.address.city}, UK</span>
          `;

          newItem.addEventListener('mousedown', () => {
            const e = document.createEvent('Event');
            e.initEvent('submit', true, true);
            searchInput.form.dispatchEvent(e);
          });

          autocomplete.insertBefore(newItem, autocomplete.firstChild);
        });

        if (results.response.count > 0) {
          autocomplete.style.display = 'block';
        }
      });
    }
  });

  searchInput.addEventListener('keydown', (e) => {
    const selected = $('.pac-item-selected');
    selected.removeClass('pac-item-selected');

    switch (e.key) {
      case 'ArrowUp':
        selected.prev().addClass('pac-item-selected');
        break;

      case 'ArrowDown':
        if (!selected.next()[0]) {
          $('.prefix-match').addClass('pac-item-selected');
        }
        break;
    }
  });

  // Adds styling when the stiicky element is at the top of its parent
  const locatorScroll = document.querySelector('.Locator-content');
  if (locatorScroll) {
    locatorScroll.addEventListener('scroll', () => {
      if (locatorScroll.scrollTop > 264) {
        locatorScroll.classList.add('is-stuck');
      } else {
        locatorScroll.classList.remove('is-stuck');
      }
    })
  }
});
